import React from "react"
import { PageProps } from "gatsby"
import { useIntl } from "gatsby-plugin-intl"
import * as styles from "./press.module.scss"

import PressLogo from "../../assets/images/press-logo.svg"
import SEO from "../../components/seo"
import LayoutNoForm from "../../components/Layout/LayoutNoForm"



const Press: React.FC<PageProps> = ({ location }) => {
	const intl = useIntl()

	return (
		<LayoutNoForm location={location}>
			<SEO
				language={intl.locale}
				description={intl.formatMessage({ id: "press.seo.description" })}
				title={intl.formatMessage({ id: "press.seo.title" })}
				pathname={location.pathname}
			/>
			<div className={styles.press}>
				<h1>{intl.formatMessage({ id: "press.title" })}</h1>
				<ul className={styles.pressList}>
					<li>
						<a className={styles.pressLink} href="/files/logo.svg" target="_blank"><div className={styles.pressImg}><img src={PressLogo} alt="invetalge logo" width={267} height={62} /></div>inventale-logo.svg</a>
					</li>
					<li>
						<a className={styles.pressLink} href="/files/logo.png" target="_blank"><div className={styles.pressImg}><img src={PressLogo} alt="invetalge logo png" width={267} height={62} /></div>inventale-logo.png (700px x 156px)</a>
					</li>
				</ul>
			</div>
		</LayoutNoForm>
	)
}

export default Press;
